'use strict';

export default class ResetPasswordSuiteWebaccessController {
  user = {
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;

  passwordResetSuccess = false;
  passwordResetExpired = false;

  /*@ngInject*/
  constructor(IntegrationService, $stateParams, Config) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.id = $stateParams.id;
    this.token = $stateParams.token;
    this.IntegrationService = IntegrationService;
  }

  submit(form) {
    this.submitted = true;

    this.passwordResetExpired = false;
    this.passwordResetSuccess = false;

    if(form.$valid) {
      this.IntegrationService.suiteResetPassword({id: this.id, token: this.token, password: this.user.newPassword},
        _ => {
          this.passwordResetSuccess = true;
        },
        err => {
          this.passwordResetExpired = true;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/reset-password-suite-webaccess/reset-password-suite-webaccess.controller.js